/* site/siteLinks.js — prototype hrefs → platform routes (2026-09-07: the LHC
 * public site, lhc-site/*.html, ported into the SPA and mounted at "/").
 * Every page of the prototype links with file names + query strings; the
 * route map below is the one in lhc-site/ARCHITECTURE.md §3. */
import React from "react";
import { Link } from "react-router-dom";
import PROTOTYPE_ROUTES from "./prototypeRoutes";

export const slugify = (s) => String(s || "").toLowerCase().trim().replace(/\s+/g, "-");

/* PROTOTYPE_ROUTES is generated from lhc-site/ and covers all 129 pages (every category listing
   and every piece); these few are extras the generator has no file for. */
const PAGES = { ...PROTOTYPE_ROUTES, "": "/", "#": "/", "admin.html": "/admin" };
const isExternal = (h) => /^(https?:)?\/\//i.test(h) || h.startsWith("mailto:") || h.startsWith("tel:");

/** "kitchen-detail.html?kitchen=frame" → "/kitchens/frame", "login.html#apply" → "/partners/apply" … */
export function toRoute(href) {
  const h = String(href == null ? "" : href).trim();
  if (!h || h === "#") return "/";
  if (isExternal(h) || h.startsWith("/")) return h;
  if (h.startsWith("#")) return h;                       // same-page anchor
  const [pathQ, hash = ""] = h.split("#");
  const [file, query = ""] = pathQ.split("?");
  const q = Object.fromEntries(new URLSearchParams(query));
  let route;
  if (file === "kitchen-detail.html") route = "/kitchens/" + (q.kitchen || "");
  else if (file === "product-detail.html") route = "/products/" + (q.category || "indoor") + "/" + (q.item || "");
  else if (file === "material-detail.html") route = "/materials/" + (q.material || "");
  else if (file === "project-detail.html") route = "/projects/" + (q.project || "");
  else if (file === "login.html" && hash === "apply") return "/partners/apply";
  else route = PAGES[file] || "/";
  return hash ? route + "#" + hash : route;
}

/** <a href="kitchens.html"> of the prototype → a router Link (or a plain <a> for anchors / external) */
export function SiteLink({ href, children, ...rest }) {
  const to = toRoute(href);
  if (isExternal(to)) return <a href={to} rel="noopener" {...rest}>{children}</a>;
  if (to.startsWith("#")) return <a href={to} {...rest}>{children}</a>;
  return <Link to={to} {...rest}>{children}</Link>;
}

/** the prototype's honesty flag — renders nothing for verified content */
export function StatusNote({ status, children, className = "", ...rest }) {
  if (!status || status === "verified") return null;
  return <p className={`status-note is-${status} ${className}`.trim()} {...rest}>{children}</p>;
}

/** split "Horizon · Open · Aria" into its parts */
export const splitSubs = (sub) => String(sub || "").split(" · ").map((s) => s.trim()).filter(Boolean);

/** where a world's subcategory leads: a kitchens sub is a LINE (/kitchens/horizon), every other
    world's sub is a CATEGORY LISTING (/indoor/sofas, /systems/wardrobes, /outdoor/dining-chairs) —
    the same shape the prototype's own subHref() resolves to. */
export function subHref(worldId, sub) {
  return `/${worldId}/${slugify(sub)}`;
}
export const worldHref = (worldId) => ({ kitchens: "/kitchens", systems: "/systems", indoor: "/indoor", outdoor: "/outdoor" }[worldId] || "/#products");
